export default __webpack_public_path__ + "static/media/carib.47437255.mp4";